import { cn } from '@/lib/utils';

import { LINE_CLAMP, sizingClass, TEXT_STYLE, TONE_CLASS } from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

const clampClass = (lines: number | undefined) =>
  lines !== undefined && lines > 0
    ? LINE_CLAMP[Math.min(Math.floor(lines), LINE_CLAMP.length) - 1]
    : undefined;

// A clamped paragraph is a snippet or a quote, so it reads a step quieter
export const Paragraph: ComponentFn<typeof catalog, 'Paragraph'> = ({
  props,
}) => {
  if (!props.text) return null;
  return (
    <p
      className={cn(
        'min-w-0 whitespace-pre-wrap break-words',
        TEXT_STYLE[props.textStyle ?? 'body'],
        TONE_CLASS[props.tone ?? (props.lines ? 'subtle' : 'default')],
        clampClass(props.lines),
        sizingClass(props.sizing)
      )}
    >
      {props.text}
    </p>
  );
};
